import { format } from 'date-fns'
import Vue from 'vue'

function fmtDate (date) {
  return date ? format(date, 'DD MMM YYYY') : ''
}

Vue.filter('fmtDate', fmtDate)

export {
  fmtDate
}
